"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDurationToDateConsideringSomeDays = exports.datepickerFixedDays = exports.convertDate = exports.isBeforeNotSame = void 0;
const dateFns = __importStar(require("date-fns"));
const isBeforeNotSame = (startDate, endDate) => dateFns.isBefore(endDate, startDate) && !dateFns.isSameDay(startDate, endDate);
exports.isBeforeNotSame = isBeforeNotSame;
const convertDate = (date) => {
    try {
        if (date)
            return new Date(date);
        return undefined;
    }
    catch (e) {
        return undefined;
    }
};
exports.convertDate = convertDate;
// Datepicker starts on Sunday!
exports.datepickerFixedDays = [7, 1, 2, 3, 4, 5, 6];
const addDurationToDateConsideringSomeDays = (currentDate, duration, shouldConsiderDateTime) => {
    const nextMorning = dateFns.startOfDay(dateFns.addDays(currentDate, 1));
    if (!shouldConsiderDateTime(currentDate))
        return (0, exports.addDurationToDateConsideringSomeDays)(nextMorning, duration, shouldConsiderDateTime);
    if (dateFns.formatDuration(duration) !== '') {
        const currentDatePlusNotice = dateFns.add(currentDate, duration);
        return dateFns.isBefore(currentDatePlusNotice, nextMorning)
            ? (0, exports.addDurationToDateConsideringSomeDays)(currentDatePlusNotice, {}, shouldConsiderDateTime)
            : (0, exports.addDurationToDateConsideringSomeDays)(nextMorning, dateFns.intervalToDuration({ start: nextMorning, end: currentDatePlusNotice }), shouldConsiderDateTime);
    }
    return currentDate;
};
exports.addDurationToDateConsideringSomeDays = addDurationToDateConsideringSomeDays;
